import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PurchaseOrderModel, SupplierModel, JumboInspectionModel, WorkPlanJumboMasterModel, Modules, Responsibility, DocumentCode, ActiveDocumentVersionVm } from 'shared/models';
import { CompanyInfo } from 'shared/models';
import { AuthService } from 'shared/core';
import { DocumentService } from 'shared/core';
import JsBarcode from 'jsbarcode';

@Component({
    selector: 'app-inspectionallprint',
    templateUrl: './inspectionallprint.component.html',
    styleUrls: ['./inspectionallprint.component.css'],
    standalone: false
})
export class InspectionAllPrintComponent implements OnInit {
  ApiUrl = environment.Api_Url;
  PurchaseOrderList: PurchaseOrderModel[] = [];
  PurchaseOrder!: PurchaseOrderModel;
  NewSupplier: SupplierModel = new SupplierModel();
  isVisible = false;
  isLoading: boolean = false;
  isTableLoading: boolean = false;
  typeList: any[] = [];
  PopUpTitle: string = 'Add New Production';
  searchValue = '';
  visible = false;
  private route$: Subscription = new Subscription();
  Poid = 0;
  Jumboid = 0;
  InspectionId = 0;
  Company = {
    CompanyName: '',
    Contact: '',
    Email: '',
    Address: '',
    GST: '',
  };
  JumboData = {
    JUMBOROLLID: '',
    ITEMNAME: '',
    PRODUCTCODE: '',
    GRAIN: '',
    COLOUR: '',
    FINISH: '',
    THICKNESS: '',
    WIDTH: '',
    LENGTH: '',
    GRADE: '',
    INSPECTEDBY: '',
  }
  jumboTableData: WorkPlanJumboMasterModel[] = [];
  JumboInspection: JumboInspectionModel[] = [];
  isLoaded = false;
  permission = {
    View: false
  }

  // Barcode-related properties
  HasBarcodeData: boolean = false;
  isLegacyOrder: boolean = false; // Track if this is a legacy order without inventory integration
  BarcodeData: any = {
    BarcodeValue: '',
    ShortCode: '',
    BatchNo: '',
    IsValid: false
  };

  // Loading state management
  private logoLoaded: boolean = false;
  private barcodesLoaded: boolean = false;
  private printTriggered: boolean = false;

  // Document version for IATF compliance
  ActiveDocumentVersion: ActiveDocumentVersionVm;

  constructor(
    private fb: UntypedFormBuilder,
    public http: HttpClient,
    private route: ActivatedRoute,
    private auth: AuthService,
    private router: Router,
    private documentService: DocumentService
  ) { }

  ngOnInit() {
    // this.permission.View = this.auth.CheckResponsibility(Modules.FinalInspection, Responsibility.View);
    // if (this.permission.View != true) {
    //   this.router.navigate(['/home/unauthorized']);
    // }
    this.route$ = this.route.params.subscribe((params: Params) => {
      this.Poid = params['id'];
      this.Jumboid = params['JumboId'];
    });
    this.Company.CompanyName = CompanyInfo.CompanyName;
    this.Company.Contact = CompanyInfo.Contact;
    this.Company.Email = CompanyInfo.Email;
    this.Company.Address = CompanyInfo.ShortAddress;
    // this.Company.GST = CompanyInfo.GST;
    // this.Company.Website = CompanyInfo.Website;
    //this.OpenViewPop();
    this.GetDocumentVersion();
  }

  GetDocumentVersion() {
    this.documentService.getActiveVersionByCode(DocumentCode.InspectionLabel)
      .subscribe(res => {
        this.ActiveDocumentVersion = res;
      });
  }

  GetAllSupplier() {
    this.isTableLoading = true;
    let url = this.ApiUrl + 'supplier/getallsuppliers';
    this.http.get<SupplierModel[]>(url).subscribe(
      (res) => {
        this.NewSupplier = res.filter(
          (x) => x.SupplierId == this.PurchaseOrder.SupplierId
        )[0];

      },
      (res) => { }
    );
  }
  getJumboRollsById(): void {
    let url = this.ApiUrl + 'workplan/getworkplanjumbobyworkplanordersid';
    this.http.get<any>(url + '/' + this.Poid).subscribe(
      (res) => {
        this.jumboTableData = res.Data;

        this.jumboTableData = this.jumboTableData.filter(x => x.WorkPlanJumboMasterId == this.Jumboid)
        this.JumboData.JUMBOROLLID = this.jumboTableData[0].JumboNo;
        this.JumboInspection = this.jumboTableData[0].JumboInspection;

        // ✅ UPDATED: Load actual barcode data from JumboInspection instead of test data
        this.loadBarcodeDataFromInspections(this.JumboInspection);

        // ✅ UPDATED: Don't trigger print immediately - wait for all elements to load
        this.checkAndTriggerPrint();
        console.log(this.jumboTableData)

      });
  }
  OpenViewPop() {

    let url = this.ApiUrl + 'saleorder/getsaleorderdatabyidforgradeprint/' + this.Poid;
    this.http.get<any>(url).subscribe((res) => {
      this.getJumboRollsById();
      //this.Orderlist = res;
      console.log(res)

      // ✅ BACKWARD COMPATIBILITY: Detect legacy orders without inventory integration
      this.detectLegacyOrder(res);

      this.JumboData.COLOUR = res.SaleOrderProduction.ColorCode
      this.JumboData.GRAIN = res.SaleOrderProduction.GrainCode
      this.JumboData.THICKNESS = res.SaleOrderProduction.ThicknessValue
      this.JumboData.PRODUCTCODE = res.SaleOrderProduction.ProductCode
      this.JumboData.WIDTH = res.SaleOrderProduction.WidthNumber
      this.JumboData.FINISH = res.FinishCode
      this.JumboData.ITEMNAME = res.SaleOrderProduction.ManufacturingProductName
      this.JumboData.PRODUCTCODE = res.SaleFormulationCode
    });
  }
  CheckOnload() {
    this.logoLoaded = true;
    this.OpenViewPop();
    // ✅ UPDATED: Check if we can trigger print after logo is loaded
    this.checkAndTriggerPrint();
  }

  /**
   * ✅ BACKWARD COMPATIBILITY: Check if barcode should be displayed
   * Only show barcode for modern orders with inventory integration
   */
  shouldShowBarcode(): boolean {
    return !this.isLegacyOrder && this.HasBarcodeData && this.BarcodeData !== null && this.BarcodeData.IsValid;
  }

  /**
   * Get batch number for display
   */
  getBatchNumber(): string {
    return this.BarcodeData?.BatchNo || '';
  }

  /**
   * Get barcode value for display
   */
  getBarcodeValue(): string {
    return this.BarcodeData?.BarcodeValue || '';
  }

  /**
   * ✅ UPDATED: Generate horizontal barcode using actual data from each inspection item
   */
  generateHorizontalBarcodes(): void {
    if (this.shouldShowBarcode()) {
      setTimeout(() => {
        // Generate barcode for each inspection item using its actual barcode data
        this.JumboInspection.forEach((inspection, index) => {
          const barcodeElement = document.getElementById(`inspection-barcode-horizontal-${index}`);
          if (barcodeElement && inspection.LabelSerialNo) {
            // Use actual barcode value from inspection
            JsBarcode(barcodeElement, inspection.LabelSerialNo, {
              format: 'CODE128',
              width: 2,
              height: 40,
              displayValue: true, // Show serial number below barcode
              fontSize: 12,
              textAlign: 'center',
              textPosition: 'bottom',
              textMargin: 2,
              fontOptions: 'bold',
              font: 'Arial',
              background: '#ffffff',
              lineColor: '#000000',
              margin: 5
            });
          }
        });

        // ✅ UPDATED: Signal that all barcodes are loaded and check if we can trigger print
        this.barcodesLoaded = true;
        this.checkAndTriggerPrint();
      }, 100);
    } else {
      // ✅ UPDATED: If no barcodes should be shown, mark as loaded immediately
      this.barcodesLoaded = true;
      this.checkAndTriggerPrint();
    }
  }

  /**
   * ✅ UPDATED: Load actual barcode data from JumboInspection objects
   */
  loadBarcodeDataFromInspections(inspections: any[]): void {
    // ✅ BACKWARD COMPATIBILITY: Only load barcode data for modern orders
    if (!this.isLegacyOrder && inspections && inspections.length > 0) {
      // Check if any inspection has barcode data
      const hasAnyBarcodeData = inspections.some(inspection => inspection.LabelSerialNo);

      if (hasAnyBarcodeData) {
        // Use the first inspection with barcode data for the main BarcodeData object
        const firstBarcodeInspection = inspections.find(inspection => inspection.LabelSerialNo);
        this.BarcodeData = {
          BarcodeValue: firstBarcodeInspection.LabelSerialNo,
          ShortCode: firstBarcodeInspection.LabelShortCode || firstBarcodeInspection.ShortCode,
          BatchNo: firstBarcodeInspection.StockBatch || firstBarcodeInspection.BatchNo,
          IsValid: true
        };
        this.HasBarcodeData = true;

        // Generate barcodes after data is loaded
        this.generateHorizontalBarcodes();

        console.log('✅ Barcode data loaded from inspections:', this.BarcodeData);
      } else {
        console.log('🔄 No Barcode Data: No barcode information found in inspections');
        this.HasBarcodeData = false;
      }
    } else {
      console.log('🔄 Legacy Order or No Inspections: Skipping barcode initialization for all print');
      this.HasBarcodeData = false;
    }
  }

  /**
   * ✅ BACKWARD COMPATIBILITY: Detect legacy orders without inventory integration
   * Legacy orders have ProductId <= 0 or null, indicating they were created before inventory system
   */
  private detectLegacyOrder(saleOrder: any): void {
    this.isLegacyOrder = !saleOrder?.SaleOrderProduction?.ProductId || saleOrder.SaleOrderProduction.ProductId <= 0;

    if (this.isLegacyOrder) {
      console.log('🔄 Legacy Order Detected: Barcode functionality will be disabled for this all print');
    } else {
      console.log('✅ Modern Order Detected: Full barcode functionality available for all print');
    }
  }

  /**
   * ✅ NEW: Check if all elements are loaded and trigger print when ready
   * This ensures both logo image and all barcodes are fully rendered before printing
   */
  private checkAndTriggerPrint(): void {
    // Check if we've already triggered print to avoid multiple calls
    if (this.printTriggered) {
      return;
    }

    // For legacy orders, only wait for logo to load (no barcodes)
    const allElementsLoaded = this.isLegacyOrder
      ? this.logoLoaded
      : this.logoLoaded && this.barcodesLoaded;

    if (allElementsLoaded) {
      this.printTriggered = true;
      console.log('✅ All elements loaded, triggering print dialog for all inspections');

      // Small delay to ensure DOM is fully updated
      setTimeout(() => {
        window.print();
        window.onafterprint = () => {
          window.close();
        };
      }, 50);
    } else {
      console.log('⏳ Waiting for elements to load...', {
        logoLoaded: this.logoLoaded,
        barcodesLoaded: this.barcodesLoaded,
        isLegacyOrder: this.isLegacyOrder
      });
    }
  }

  /**
   * ✅ QR CODE GENERATION: Generate QR code data with all label details (excluding header)
   * Returns a formatted string with all inspection data for QR code scanning
   */
  getQRCodeData(data: any): string {
    if (!data) {
      return '';
    }

    // Build QR code data string with all label information (excluding company header)
    const qrData = [
      `ROLL NO: ${data.Code || ''}`,
      `ITEM: ${this.JumboData.ITEMNAME || ''}`,
      `P.CODE: ${this.JumboData.PRODUCTCODE || ''}`,
      `GRAIN: ${this.JumboData.GRAIN || ''}`,
      `COLOR: ${this.JumboData.COLOUR || ''}`,
      `BY: ${data.InspectedBy || ''}`,
      `THICK: ${this.JumboData.THICKNESS || ''}`,
      `WIDTH: ${this.JumboData.WIDTH || ''}`,
      `LENGTH: ${data.Quantity || ''}`,
      `GRADE: ${data.Grade || ''}`,
      `FINISH: ${this.JumboData.FINISH || ''}`
    ];

    // Add batch number if available
    const batchNo = data.StockBatch || data.BatchNo || '';
    if (batchNo) {
      qrData.push(`BATCH: ${batchNo}`);
    }

    // Add barcode information if available
    if (data.LabelSerialNo) {
      qrData.push(`BARCODE: ${data.LabelSerialNo}`);
      if (data.LabelShortCode) {
        qrData.push(`SHORT CODE: ${data.LabelShortCode}`);
      }
    }

    // Join all data with newlines for QR code
    return qrData.filter(line => line.trim().length > 0).join('\n');
  }
}





